import { computed, defineAsyncComponent } from 'vue'
import { useModalsStore } from 'stores/modals'
import { useUserAuthStore } from 'stores/user/auth'
import { useUserBonusesStore } from 'stores/user/bonuses'
import { BONUS_GAMES_STEP_CONDITIONS, BONUS_STEP_CONDITIONS } from 'src/common/dictionary'

function noop() {}

let skipNextBonusSportModalWatch = false

export function markBonusSportModalAsHandled() {
  skipNextBonusSportModalWatch = true
}

export function consumeHandledBonusSportModal() {
  if (!skipNextBonusSportModalWatch) {
    return false
  }

  skipNextBonusSportModalWatch = false
  return true
}

export function useBonusSportModal() {
  const modalsStore = useModalsStore()
  const userAuthStore = useUserAuthStore()
  const userBonusesStore = useUserBonusesStore()

  function checkAndShowNonBonusGameModal(gamePath = noop) {
    const getActiveStep = userBonusesStore.getActiveStep
    const getUserBonusBalanceOn = userAuthStore.getUserBonusBalanceOn

    if (getActiveStep?.conditionDetails?.includes(8) && getUserBonusBalanceOn) {
      modalsStore.pushModal({
        componentName: defineAsyncComponent(() => import('components/games/NonBonusGameModal.vue')),
        props: { gamePath },
      })
      return true
    }

    return false
  }

  function checkAndShowNonBonusVagerModal(gamePath = noop) {
    const getActiveStep = userBonusesStore.getActiveStep
    const getUserBonusBalanceOn = userAuthStore.getUserBonusBalanceOn
    const getBonusType = computed(() => userBonusesStore.getBonusType)

    const isSwitchBalanceDenied =
      getActiveStep?.conditionDetails?.includes(4) ||
      getActiveStep?.conditionDetails?.includes(5) ||
      getActiveStep?.conditionDetails?.includes(8)

    const isNoVagerGame =
      isSwitchBalanceDenied && !getUserBonusBalanceOn && BONUS_GAMES_STEP_CONDITIONS.includes(getActiveStep?.condition)

    if (isNoVagerGame && getBonusType.value !== 'Sports') {
      modalsStore.pushModal({
        componentName: defineAsyncComponent(() => import('components/games/NonBonusVagerModal.vue')),
        props: { gamePath },
      })
      return true
    }

    return false
  }

  function shouldShowNonBonusVagerGameModal(gameId) {
    const activeStep = userBonusesStore.getActiveStep
    const program = userBonusesStore.getActiveUserProgram?.program
    const isSwitchBalanceDenied = program?.processConditions?.includes(4) || program?.processConditions?.includes(5)
    const isVagerByBonusBalanceStep = activeStep?.condition === BONUS_STEP_CONDITIONS.VAGER_BY_BONUS_BALANCE
    const shouldWarnForTurnover = activeStep?.condition === BONUS_STEP_CONDITIONS.TURNOVER
    const shouldWarnForVagerByBonusBalance =
      isVagerByBonusBalanceStep && isSwitchBalanceDenied && !userAuthStore.getUserBonusBalanceOn
    const isNoBonusGame = !userBonusesStore.getBonusGameIdsList?.includes(gameId)

    return (shouldWarnForTurnover || shouldWarnForVagerByBonusBalance) && isNoBonusGame
  }

  function showNonBonusVagerGameModal(gamePath = noop) {
    modalsStore.pushModal({
      componentName: defineAsyncComponent(() => import('components/games/NonBonusVagerModal.vue')),
      isMaximized: false,
      position: 'bottom',
      props: { gamePath },
    })
  }

  function checkAndShowNonBonusVagerGameModal(gameId, gamePath = noop) {
    if (!shouldShowNonBonusVagerGameModal(gameId)) {
      return false
    }

    showNonBonusVagerGameModal(gamePath)
    return true
  }

  function checkAndShowModal(gamePath = noop) {
    if (checkAndShowNonBonusGameModal(gamePath)) {
      return true
    }

    return checkAndShowNonBonusVagerModal(gamePath)
  }

  return {
    checkAndShowNonBonusGameModal,
    checkAndShowNonBonusVagerModal,
    checkAndShowNonBonusVagerGameModal,
    checkAndShowModal,
    shouldShowNonBonusVagerGameModal,
    showNonBonusVagerGameModal,
  }
}
